import React from 'react'
import { Skeleton, Divider } from 'antd'
import { ItemBg, ItemAttachmentLabel } from './GridTinTucStyled'

const GridItemSkeleton = ({ width }) => {
  return (
    <div style={{ width }}>
      <ItemBg>
        {/* Header */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: 12,
          }}>
          <div style={{ flex: 1, marginRight: 12 }}>
            <Skeleton.Button
              active
              size="large"
              style={{
                width: '85%',
                height: 20,
                borderRadius: 4,
              }}
            />
          </div>
          <Skeleton.Button
            active
            size="small"
            style={{
              width: 32,
              height: 32,
              borderRadius: 4,
              flexShrink: 0,
            }}
          />
        </div>

        {/* Divider */}
        <Divider style={{ margin: '12px 0' }} />

        {/* Content */}
        <div style={{ flexGrow: 1, marginBottom: 16 }}>
          <Skeleton
            active
            paragraph={{
              rows: 3,
              width: ['100%', '100%', '95%'],
            }}
            title={false}
          />
        </div>

        {/* Attachments Section */}
        <div style={{ marginTop: 'auto' }}>
          <Skeleton.Button
            active
            size="small"
            style={{
              width: 120,
              height: 14,
              marginBottom: 12,
            }}
          />
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Skeleton.Button
              active
              style={{
                width: '100%',
                height: 28,
                borderRadius: 4,
              }}
            />
          </div>
        </div>
      </ItemBg>
    </div>
  )
}

export default GridItemSkeleton
